module.exports = __webpack_public_path__ + "static/media/cardbg.188d0916.jpg";